// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "currency-3QxRi";
var _4 = "arrowIcon-1ojKG";
var _5 = "selector-1ScYO";
var _6 = "arrowIcon_flipped-2_Bhw";
export { _1 as "__esModule", _2 as "mobile", _3 as "currency", _4 as "arrowIcon", _5 as "selector", _6 as "arrowIcon_flipped" }
export default { "__esModule": _1, "mobile": _2, "currency": _3, "arrowIcon": _4, "selector": _5, "arrowIcon_flipped": _6 }
